export default __webpack_public_path__ + "static/media/emptyicons.0693130e.svg";